export const getStudyFlowId = state => state.studyFlows.studyFlow.id;
export const getStudyFlowEmail = state => state.studyFlows.studyFlow.email;
export const getStudyFlowData = state => state.studyFlows.studyFlow;
export const studyFlowIsFetching = state => state.studyFlows.loading;